import React from "react";
import PropTypes from "prop-types";
import "./inline-card.scss";

const InlineCard = ({ slug, url, image, title, introduction }) => {
  return (
    <a className="i-card" key={slug} href={url} data-vars-slug={slug}>
      <div className="i-card__image">
        <amp-img
          src={image}
          width="160"
          height="106"
          layout="flex-item"
          alt={title}
        />
      </div>
      <div className="i-card__content">
        <p className="i-card__title">{title}</p>
        {introduction && (
          <p className="i-card__standfirst">
            {introduction
              .split(" ")
              .slice(0, 18)
              .join(" ")}...
          </p>
        )}
      </div>
    </a>
  );
};

InlineCard.propTypes = {
  title: PropTypes.string,
  introduction: PropTypes.string,
  image: PropTypes.string,
  slug: PropTypes.string,
  url: PropTypes.string
};

export default InlineCard;



// WEBPACK FOOTER //
// ./src/components/inline-card/inline-card.js